<template>
  <p class="competitor-notice" :class="{ 'on-dark': onDark }" data-competitor-notice>
    Facts last verified <time v-if="iso" :datetime="iso">{{ date }}</time><template v-else>{{ date }}</template> from {{ names }}{{ plural ? "'" : "'s" }} public pages.
    <template v-if="plural">{{ names }} are trademarks of their owners; Workspace369 isn't affiliated with or endorsed by them.</template
    ><template v-else>{{ names }} is a trademark of its owner; Workspace369 isn't affiliated with or endorsed by it.</template>
    Spot an error? Tell us at <a href="mailto:support@workspace369.com">support@workspace369.com</a> and we'll fix it.
  </p>
</template>

<script setup>
// The "last verified" and non-affiliation line at the top of every compare, alternatives and
// switch page (A35, MKT-4/MKT-5; wording from legal-drafts/in-product-notices.md 11.1).
const props = defineProps({
  competitor: { type: String, required: true },
  date: { type: String, required: true },
  iso: { type: String, default: "" },
  // The alternatives hero is navy in both colour modes; compare and switch heroes stay light.
  onDark: { type: Boolean, default: false },
});
// "HoneyBook vs Dubsado" names two companies.
const plural = computed(() => / vs /i.test(props.competitor));
const names = computed(() => props.competitor.replace(/ vs /i, " and "));
</script>

<style scoped>
.competitor-notice {
  margin: 1rem 0 0;
  max-width: 44rem;
  font-size: 0.8125rem;
  line-height: 1.55;
  color: #475569;
}
.competitor-notice a { text-decoration: underline; text-underline-offset: 2px; }
.competitor-notice.on-dark { color: #cbd5e1; }
.competitor-notice.on-dark a { color: #67e8f9; }
</style>
